"use client"
import { useEffect } from "react";
import { BiErrorCircle } from "react-icons/bi";

type ErrorProps = {
  error: Error;
};

export function ErrorFallback({ error }: ErrorProps) {
  // Extract error location from stack trace
  const extractErrorLocation = (stack: string | undefined): string => {
    if (!stack) return "Unknown location";
    const match = stack.match(/(?:at\s+.*\()?(.*):(\d+):(\d+)\)?/); // Improved regex
    return match ? `File: ${match[1]}, Line: ${match[2]}` : "Location not found";
  };

  const error_location = extractErrorLocation(error.stack);
  
  useEffect(() => {
    const sendLog = async () => {
      try {
        const [response1, response2] = await Promise.all([
          fetch("/api/slack-log", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ error_message: error.message, error_location }),
          }),
          fetch("/api/backend-log", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ error_message: error.message, error_location }),
          }),
        ]);

        if (!response1.ok || !response2.ok) {
          console.error("Error logging failed", { response1, response2 });
        }
      } catch (err) {
        console.error("Failed to send error logs:", err);
      }
    };

    sendLog();
  }, [error, error_location]); // Runs only when `error` changes

  return (
    <div className="bg-gray-100 rounded-xl p-10 flex flex-col items-center gap-2 mt-[250px]">
      <BiErrorCircle size={40} color="red" />
      <p className="font-bold">Something went wrong.</p>
      <p>Our engineers have been notified and are actively working on a fix. Rest assured, this issue will be resolved soon.</p>
    </div>
  );
}
